export function formatLineBreaks(text: string) {
  return text.split("\n").map((str) => (
    <>
      <br />
      {str}
    </>
  ));
}
